// SHOULD ALWAYS BE === when deployed
export const isDev = process.env.REACT_APP_ENV === 'development';
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
